import { Frame } from "./DeckShell";
import { logoOf, Wordmark } from "./brands";

/* «The proposal» — collab-statement, kun i mottakerlaget (slide 02 i alle deck). Monokrom lockup som objekt: ordmerket i Geist,
   × i grå, mottakerens logo optisk balansert (logo-`scale` dempes til det halve — den er tunet for masthead-størrelse).
   Kicker «The proposal» holder den ydmyk; indeksraden sier hva den betyr. */
const logoHeight = (name) => {
  const l = logoOf(name);
  if (!l) return 84;
  const s = l.scale || 1;
  return Math.round((84 * (1 + (s - 1) * 0.35)) / s);
};

export const Proposal = ({ nr, mottaker, sentence, index }) => (
  <Frame nr={nr} label="The proposal" mottaker={mottaker} className="hd-proposal hd-light">
    <div className="hd-prop-lockup" data-testid="hd-proposal-lockup">
      <span className="wm">Norwegian AI Summit</span>
      <span className="row"><span className="x" aria-hidden>×</span><Wordmark name={mottaker} h={logoHeight(mottaker)} className="lg" /></span>
    </div>
    <p className="hd-prop-p" data-testid="hd-proposal-p">{sentence}</p>
    <div className="hd-index hd-prop-idx" data-testid="hd-proposal-index">
      {index.map(([k, v]) => <span key={k}><i className="k">{k}</i>{v}</span>)}
    </div>
  </Frame>
);
